import { CampaignForView } from "./types";

export function buildTexterLink(campaign: CampaignForView): {
  fullLink: string;
  path: string;
} {
  const path = `/join?token=${encodeURIComponent(campaign.inbox!.joinToken!)}&inbox=${campaign.inbox!.id}`;
  return {
    fullLink: `${document.location.protocol}//${document.location.host}${path}`,
    path,
  };
}
